'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refinementKeySort = exports.refinementSort = exports.getCategoriesJoined = exports.getEncodedBrowseCategories = exports.getRefinementPath = exports.getOptionsPath = exports.getCategoryFilterPath = exports.getBrowsePath = exports.getSearchPath = undefined;

var _FindabilityDecoder = require('../FindabilityDecoder/FindabilityDecoder');

var _FindabilityDecoder2 = _interopRequireDefault(_FindabilityDecoder);

var _config = require('../config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getSearchPath = function getSearchPath(searchTerm) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var path = void 0;

  if (searchTerm) {
    var term = searchTerm.trim().toLowerCase();
    var pageType = params.isCannedSearch ? 'list' : 'search';
    path = '/' + pageType + '/' + encodeURIComponent(term) + '/';
    path = _FindabilityDecoder2.default.encode(path);
  } else {
    throw new Error('No search term supplied');
  }

  path += getCommonParametersPath(params);

  return path;
};

var getBrowsePath = function getBrowsePath() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var path = void 0;

  if (params.categoryId) {
    var pageType = params.isClearance ? 'clearance' : 'browse';
    path = '/' + pageType + '/' + getCategoriesJoined(getEncodedBrowseCategories(params.categories)) + '/';
  } else {
    throw new Error('No category id supplied');
  }

  path += getCommonParametersPath(params, true);

  return path;
};

var getCategoriesJoined = function getCategoriesJoined(categories) {
  return categories ? categories.join('/') : '';
};

var getEncodedBrowseCategories = function getEncodedBrowseCategories(categories) {
  return categories ? categories.map(function (category) {
    return _FindabilityDecoder2.default.stripPunctuation(_FindabilityDecoder2.default.hyphenateSpaces(category));
  }).filter(function (category) {
    return category;
  }) : '';
};

var getCommonParametersPath = function getCommonParametersPath(params) {
  var isBrowse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var sortBy = params.sortBy,
      pageNumber = params.pageNumber,
      searchType = params.searchType;

  var path = '';

  var categoryPath = getCategoryFilterPath(params.categoryId, isBrowse);

  if (typeof params.filterUriFragments !== 'undefined' && params.filterUriFragments) {
    delete params.filterUriFragments['category'];
  }

  var refinementPath = getRefinementPath(params.filterUriFragments);
  var optionalPath = getOptionsPath(pageNumber, sortBy, searchType);
  path += '' + categoryPath + refinementPath + optionalPath;

  return path;
};

var getCategoryFilterPath = function getCategoryFilterPath(categoryId) {
  var isBrowse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isBrowse) {
    return categoryId ? 'c:' + categoryId + '/' : '';
  }

  return categoryId ? 'category:' + categoryId + '/' : '';
};

var getRefinementPath = function getRefinementPath(filterUriFragments) {
  if (!filterUriFragments || Object.keys(filterUriFragments).length < 1) {
    return '';
  }

  /**
   * Search engine encodes the filter value but not the type
   * i.e filter[not encoded type] = encodedValue
   */
  var encodeRefinementValue = function encodeRefinementValue(refinement) {
    return _FindabilityDecoder2.default.encode(refinement.replace(/\+/g, '%20').replace(/,/g, '%2C').replace(/%2C/g, '%252C'));
  };
  var encodeRefinementName = function encodeRefinementName(refinement) {
    return _FindabilityDecoder2.default.encode(encodeURIComponent(refinement).replace('%2F', '%252F'));
  };

  var urlString = '';
  var filterKeys = [];
  filterKeys.push.apply(filterKeys, _toConsumableArray(Object.keys(filterUriFragments)));
  filterKeys.sort(refinementKeySort);
  filterKeys.forEach(function (facet) {
    filterUriFragments[facet].sort(refinementSort);
    filterUriFragments[facet].forEach(function (filters, i) {
      if (i === 0) {
        urlString += encodeRefinementName(facet) + ':' + encodeRefinementValue(filters);
      } else {
        urlString += ',' + encodeRefinementValue(filters);
      }
      if (i + 1 === filterUriFragments[facet].length) {
        urlString += '/';
      }
    });
  });

  return urlString;
};

var refinementKeySort = function refinementKeySort(a, b) {
  var nameA = a.toUpperCase();
  var nameB = b.toUpperCase();
  var brandsLabel = 'brands';

  if (nameA === brandsLabel.toUpperCase()) {
    return -1;
  }

  if (nameB === brandsLabel.toUpperCase()) {
    return 1;
  }

  if (nameA < nameB) {
    return -1;
  }

  if (nameA > nameB) {
    return 1;
  }

  return 0;
};

var refinementSort = function refinementSort(a, b) {
  var nameA = a.toUpperCase();
  var nameB = b.toUpperCase();

  if (nameA < nameB) {
    return -1;
  }

  if (nameA > nameB) {
    return 1;
  }

  return 0;
};

var getOptionsPath = function getOptionsPath(pageNumber, sortBy, searchType) {
  var optionalPath = 'opt/';

  var getPageNumber = function getPageNumber() {
    return pageNumber === 1 || !pageNumber ? '' : 'page:' + pageNumber + '/';
  };

  var getSortBy = function getSortBy() {
    if (!sortBy) {
      return '';
    }

    var key = Object.keys(sortBy)[0];

    var sortByObject = _config.sortByValues.find(function (value) {
      return value.key === key + '_' + sortBy[key];
    });

    return '' + (sortByObject && sortByObject.path ? sortByObject.path + '/' : '');
  };

  var getSearchType = function getSearchType() {
    if (typeof searchType === 'string' || searchType instanceof String) {
      var searchTypePath = _FindabilityDecoder2.default.encode(encodeURIComponent(searchType.toLowerCase()));
      return 'type:' + searchTypePath + '/';
    }

    return '';
  };

  if (!getPageNumber() && !getSortBy() && !getSearchType()) {
    return '';
  }

  optionalPath += getSearchType();
  optionalPath += getPageNumber();
  optionalPath += getSortBy();

  return optionalPath;
};

exports.getSearchPath = getSearchPath;
exports.getBrowsePath = getBrowsePath;
exports.getCategoryFilterPath = getCategoryFilterPath;
exports.getOptionsPath = getOptionsPath;
exports.getRefinementPath = getRefinementPath;
exports.getEncodedBrowseCategories = getEncodedBrowseCategories;
exports.getCategoriesJoined = getCategoriesJoined;
exports.refinementSort = refinementSort;
exports.refinementKeySort = refinementKeySort;
//# sourceMappingURL=BuildUrl.js.map